import { NetLogicTableConfiguration } from "@/core/NetLogicTableConfiguration";
import { useEffect, useState } from "react";

export function useNetLogicTableConfiguration() {
  const [configurations, setConfigurations] = useState({});

  const isValid =
    configurations?.externalId &&
    configurations?.apiUrl &&
    configurations?.orderEmployee &&
    configurations?.orderType &&
    configurations?.revenueCenter &&
    configurations?.tenderMediaIncrement &&
    configurations?.tenderMediaClosing &&
    configurations?.callWaiterSku;

  useEffect(() => {
    const tableConfigurations = NetLogicTableConfiguration.fromStorage();

    setConfigurations(tableConfigurations);

    tableConfigurations.addListener(() => {
      const updatedTableConfigurations =
        NetLogicTableConfiguration.fromStorage();
      setConfigurations(updatedTableConfigurations);
    });

    return () => tableConfigurations.removeListener();
  }, []);

  const persistConfigurations = () => {
    const tableConfigurations = NetLogicTableConfiguration.fromStorage();
    tableConfigurations.update(configurations);
  };

  const updateConfigurations = (newConfigurations) => {
    if (newConfigurations === null) {
      setConfigurations(null);
    } else {
      setConfigurations({
        ...configurations,
        ...newConfigurations,
      });
    }
  };

  return [configurations, updateConfigurations, persistConfigurations, isValid];
}
